import {
    Component,
    computed,
    inject,
    Input,
    signal,
    ViewChild,
} from '@angular/core';
import {Button, ButtonDirective} from 'primeng/button';
import {TooltipModule} from 'primeng/tooltip';
import {CommonModule, Location, NgIf} from '@angular/common';
import {ConfirmationService, PrimeTemplate} from 'primeng/api';
import {Table, TableModule} from 'primeng/table';
import {TagModule} from 'primeng/tag';
import {SolicitudEvalDocTipoInterface} from 'src/app/officials/evaluaciones/interfaces/evaluaciones.interface';
import {
    ArchivoItem,
    ProyectoItem,
} from 'src/app/users/interfaces/proyecto.interface';
import {TramiteService} from 'src/app/users/tramites/services/tramite.service';
import {DescargarPlantillaComponent} from '../../components/descargar-plantilla/descargar-plantilla.component';
import {SubirResolucionComponent} from '../../components/subir-resolucion/subir-resolucion.component';
import Swal from 'sweetalert2';
import {ConfirmPopup, ConfirmPopupModule} from 'primeng/confirmpopup';
import {ProyectoService} from 'src/app/users/proyectos/services/proyecto.service';
import {ObtencionGenerica} from '../../../interface/ver-proyecto.interface';
import {ProgressSpinnerModule} from 'primeng/progressspinner';
import {environment} from 'src/environments/environment.development';
import CONSTANTS from 'src/utils/resources/constants';
import {RecorteFotoComponent} from '../../components/recorte-foto/recorte-foto.component';
import {RequisitoService} from 'src/app/users/mnto-requisitos/services/requisito.service';
import {log} from 'logrocket';
import {LoginServices} from "../../../../../../../auth/login/services/login.service";
import { firstValueFrom } from 'rxjs';

@Component({
    selector: 'app-resoluciones',
    standalone: true,
    imports: [
        ButtonDirective,
        TooltipModule,
        Button,
        PrimeTemplate,
        TableModule,
        TagModule,
        CommonModule,
        DescargarPlantillaComponent,
        SubirResolucionComponent,
        ConfirmPopupModule,
        ProgressSpinnerModule,
        RecorteFotoComponent,
    ],
    templateUrl: './resoluciones.component.html',
    styleUrl: './resoluciones.component.scss',
})
export class ResolucionesComponent {
    protected tramiteService = inject(TramiteService);
    private confirmationService = inject(ConfirmationService);
    cols = [];
    currentAction = signal<'upload' | 'dowload' | null>(null);
    showAction = computed(() => this.currentAction() !== null);
    resolutionDialogConfig = signal({
        open: false,
        isUploadResolution: false,
    });
    openDialogResolucion: boolean = false;
    solicitudResoluciones: SolicitudEvalDocTipoInterface[] = [];

    resolucionesFilter(table: Table, event: Event) {
        table.filterGlobal(
            (event.target as HTMLInputElement).value,
            'contains'
        );
    }

    tagStyle(estado: boolean) {
        switch (estado) {
            case true:
                return {background: '#28a745'};
            case false:
                return {background: '#FF0000FF'};
            default:
                return {background: '#6c757d'};
        }
    }

    openDialog(isUploadResolution: boolean) {
        this.resolutionDialogConfig.set({
            open: true,
            isUploadResolution: isUploadResolution,
        });
    }

    closeDialogResolucion(event: boolean) {
        this.openDialogResolucion = event;
        this.openDialogResolucion = false;
        this.resolutionDialogConfig.set({
            open: false,
            isUploadResolution: false,
        });
    }

    setAction(action: 'upload' | 'dowload' | null): void {
        this.currentAction.set(action);
    }

    @ViewChild(ConfirmPopup) confirmPopup!: ConfirmPopup;

    private aprobarSolicitud() {

        this.tramiteService
            .aprobarSolicitud(this.selected?.idProyecto!)
            .subscribe({
                next: () => {
                    Swal.fire(
                        'Éxito',
                        'Solicitud aprobada correctamente',
                        'success'
                    );
                    this.is_solicitudAprobada = true;
                },
                error: (err) => {
                    Swal.fire(
                        'Error',
                        'No se pudo aprobar la solicitud',
                        'error'
                    );
                    console.error(err);
                },
            });
    }

    accept() {
        this.confirmPopup.accept();
    }

    reject() {
        this.confirmPopup.reject();
    }

    confirm(event: Event) {

        this.confirmationService.confirm({
            target: event.target as EventTarget,
            message: 'Seguro deseas aprobar la solicitud?',
            accept: () => {
                this.aprobarSolicitud();
            },
            reject: () => {
            },
        });
    }

    /*===========================================================================================*/
    /*VARIABLES ---------------------------------------------------------------------------------*/
    /*===========================================================================================*/
    //PRIVATES ------------------------------------------------------------------------------------
    static aprobada: string = 'Aprobada';
    //PRIVATES ------------------------------------------------------------------------------------
    /** Usualmente definidos para recibir los datos de los inputs */
    private consoleEnabled: boolean = CONSTANTS.consoleEnabled; //  environment.showConsole; // Cambiar a false para desactivar los logs de consola
    private _selected: ProyectoItem | null = null;
    private _registro: ObtencionGenerica = {};
    //PUBLIC --------------------------------------------------------------------------------------
    /** Usualmente definidos para ser utilizados en el html */
    public carnetData: ObtencionGenerica = {};
    public is_solicitudAprobada: boolean = false;
    public is_rp: boolean = false;
    /*===========================================================================================*/
    /*INPUTS & OUTPUTS --------------------------------------------------------------------------*/
    /*===========================================================================================*/

    //INPUTS --------------------------------------------------------------------------------------
    @Input()
    set selected(data: ProyectoItem | null) {
        this._selected = data;
        if (data) {
            //onChange detected
        }
    }

    get selected(): ProyectoItem | null {
        return this._selected;
    }

    //-------------------------------------------
    @Input()
    set registro(data: ObtencionGenerica) {
        this._registro = data;
        if (data) {
            //onChange detected
            if (this.consoleEnabled)
                console.log('IS RP:', this.RP(this.selected));
            this.is_solicitudAprobada = this.isSolicitudAprovada();
            this.is_rp = this.RP(this.selected);
        }
    }

    get registro(): ObtencionGenerica {
        return this._registro;
    }

    //OUTPUTS --------------------------------------------------------------------------------------
    /*===========================================================================================*/
    /*CONSTRUCTOR -------------------------------------------------------------------------------*/

    /*===========================================================================================*/
    constructor(
        private proyectoServices: ProyectoService,
        private requisitoService: RequisitoService,
        private loginServices: LoginServices
    ) {
    }

    /*===========================================================================================*/
    /*METHODS -----------------------------------------------------------------------------------*/

    /*===========================================================================================*/
    /**
     * Método para cargar información del carnet asociado a la solicitud seleccionada. En este caso
     * estamos utilizando la informacion del proyecto seleccionado, el cual es obtenido mediante el
     * input [selected]
     */
    async cargarCarnet(proyecto?: ProyectoItem | null): Promise<void> {
        //no hacer nada si no hay proyecto
        if (!proyecto) {
            return;
        }
        //Obtener el id de la solicitud correspondiente
        const id_Solicitud = proyecto?.idSolicitud;
        proyecto.carnetLoading = true;
        console.log('Estado de la solicitud', proyecto.estadoSolicitud);
        if (this.consoleEnabled) {
            console.log(
                `ID de solicitud en archivo {lista-proyectos-components.ts}: ${id_Solicitud}`
            );
        }
        if (!id_Solicitud) {
            if (this.consoleEnabled) {
                console.warn('ID de solicitud no disponible aún');
            }
            return;
        }
        try {
            proyecto.carnetGenerado = false;
            //comsumir API de respuesta para la generacion del carnet
            //antes de consumir el endpoint que genera el PDF
            this.proyectoServices
                .getCarnetByIdSolicitud(id_Solicitud)
                .subscribe((response) => {
                    if (response.success) {
                        //Mostrar datos de la respuesta en caso de exito
                        if (this.consoleEnabled) {
                            console.log(
                                'Informacion: ',
                                response.data?.['data']
                            );
                        }
                        //cargamos con los datos en caso de necesitarse en el futuro
                        this.carnetData = response.data?.['data'];
                        //Habilitamos la activacion del endpoint de generacion del PDF del carnet
                        proyecto.carnetGenerado = true;
                        proyecto.carnetLoading = false;
                        this.mensajeSuccess(
                            'Generado con exito',
                            'Su carnet se ha generado, ya lo puede descargar'
                        );
                    } else {
                        //Hinnabilitamos la carga del PDF del carnet
                        proyecto.carnetGenerado = false;
                        proyecto.carnetLoading = false;
                        this.mensajeWarning(
                            'Lo lamentamos',
                            'Su carnet no fue posible generarse'
                        );
                    }
                });
        } catch (error) {
            proyecto.carnetLoading = false;
            proyecto.carnetGenerado = false;
            if (this.consoleEnabled) {
                console.error('Error al cargar datos del carnet:', error);
            }
            this.mensajeWarning(
                'Lo lamentamos',
                'Su carnet no fue posible generarse, intente mas tarde'
            );
        }
    }

    recorteFotoVisible = false;
    fotoParaRecortar: string | undefined = undefined;

    async recortarFotoCarnetPDF(proyecto: ProyectoItem): Promise<void> {
        if (!proyecto) return;

        try {
            proyecto.carnetLoading = true;
            proyecto.carnetDescargado = false;

             // Llama al nuevo endpoint que retorna la imagen en base64
        const token = this.loginServices.session()?.token;
        const response = await fetch(
            `${environment.apiVucUrl}api/v1.0/archivos/fotografia/${proyecto.idProyecto}`,
            {
                method: 'GET',
                headers: { Authorization: `Bearer ${token}` }
            }
        );

        console.log('Response status:', response);

            if (!response.ok) {
                if (response.status === 404) {
                    this.mensajeWarning('Error', 'No se encontró la foto para el proyecto.');
                } else {
                    this.mensajeWarning('Error', 'No se pudo obtener la foto del carnet.');
                }
                return;
            }

        const base64 = await response.text();

        // Validar si es una imagen base64 válida (JPG/JPEG o PNG)
        if (
    !base64.startsWith('/9j') &&      // JPG/JPEG
    !base64.startsWith('iVBOR') &&    // PNG
    !base64.startsWith('Qk') &&       // BMP
    !base64.startsWith('JVBER')       // PDF
) {
    this.mensajeWarning('Error', 'La fotografía no es válida. Solo se permiten archivos JPG, JPEG, PNG, BMP o PDF.');
    return;
}

        let dataUrl = '';
if (base64.startsWith('/9j')) {
    dataUrl = `data:image/jpeg;base64,${base64}`;
} else if (base64.startsWith('iVBOR')) {
    dataUrl = `data:image/png;base64,${base64}`;
} else if (base64.startsWith('Qk')) {
    dataUrl = `data:image/bmp;base64,${base64}`;
} else if (base64.startsWith('JVBER')) {
    // PDF: necesitas convertirlo a imagen antes de mostrarlo en el cropper
    // Ejemplo usando PDF.js (debes tenerlo instalado y configurado)
    const pdfData = atob(base64);
    const pdfBlob = new Blob([Uint8Array.from(pdfData, c => c.charCodeAt(0))], { type: 'application/pdf' });
    const pdfUrl = URL.createObjectURL(pdfBlob);

    // Aquí deberías llamar a una función que convierta el PDF a imagen y luego asigne el resultado a this.fotoParaRecortar
    // Ejemplo:
    // this.convertPdfToImage(pdfUrl).then(imgBase64 => {
    //     this.fotoParaRecortar = imgBase64;
    //     this.recorteFotoVisible = true;
    // });
    // return para evitar continuar con el flujo normal
    await this.convertPdfToImage(pdfUrl).then(imgBase64 => {
        this.fotoParaRecortar = imgBase64;
        this.recorteFotoVisible = true;
    });
    return;
}

        this.fotoParaRecortar = dataUrl;
        this.recorteFotoVisible = true;

        } catch (error) {
            console.error('Error en recortarFotoCarnetPDF:', error);
            this.mensajeWarning('Error', 'No se pudo procesar la foto del carnet.');
        } finally {
            proyecto.carnetLoading = false;
        }
    }

    // ... existing code ...
    onFotoRecortada(base64: any) {
        this.recorteFotoVisible = false;
        if (this.selected && base64) {
            this.comprimirBase64(base64, 0.7).then((base64Comprimido) => {
                this.descargarCarnetPDF(this.selected!, base64Comprimido);
            });
        }
    }

    /**
     * Convierte un PDF a imagen base64 (solo la primera página).
     * Requiere que PDF.js esté disponible globalmente como 'pdfjsLib'.
     */
    async convertPdfToImage(pdfUrl: string): Promise<string> {
        // @ts-ignore
        const pdfjsLib = (window as any).pdfjsLib;
        if (!pdfjsLib) {
            this.mensajeWarning('Error', 'PDF.js no está disponible.');
            return '';
        }
        const pdf = await pdfjsLib.getDocument(pdfUrl).promise;
        const page = await pdf.getPage(1);
        const viewport = page.getViewport({ scale: 2 });
        const canvas = document.createElement('canvas');
        const context = canvas.getContext('2d');
        canvas.width = viewport.width;
        canvas.height = viewport.height;
        await page.render({ canvasContext: context, viewport }).promise;
        const imgBase64 = canvas.toDataURL('image/png');
        return imgBase64;
    }

    onRecorteFotoCerrado() {
        if (this.selected) {
            this.selected.carnetLoading = false;
        }
    }

    // Método utilitario para comprimir base64 usando canvas
    comprimirBase64(base64: string, calidad: number = 0.7): Promise<string> {
        return new Promise((resolve) => {
            const img = new Image();
            img.onload = () => {
                const canvas = document.createElement('canvas');
                canvas.width = img.width;
                canvas.height = img.height;
                const ctx = canvas.getContext('2d');
                if (ctx) {
                    ctx.drawImage(img, 0, 0);
                    // Exporta como JPEG comprimido
                    const base64Comprimido = canvas.toDataURL(
                        'image/jpeg',
                        calidad
                    );
                    resolve(base64Comprimido);
                } else {
                    // Si falla, retorna el original
                    resolve(base64);
                }
            };
            img.onerror = () => resolve(base64);
            img.src = base64;
        });
    }

    async descargarCarnetPDF(
        proyecto: ProyectoItem,
        cropData: any
    ): Promise<void> {
        if (!proyecto) return;
        const id_proyecto = proyecto.idProyecto;
        proyecto.carnetLoading = true;
        proyecto.carnetDescargado = false;
        if (!id_proyecto) {
            if (this.consoleEnabled) {
                console.warn('ID de proyecto no disponible aún');
            }
            return;
        }
        try {
            this.proyectoServices
                .generarCarnetPdf(id_proyecto, cropData)
                .subscribe({
                    next: (pdfResponse: any) => {
                        if ('success' in pdfResponse && !pdfResponse.success) {
                            proyecto.carnetDescargado = false;
                            proyecto.carnetLoading = false;
                            this.mensajeWarning(
                                'Lo lamentamos',
                                'No fue posible descargar su carnet PDF'
                            );
                            return;
                        }
                        // Cambia aquí: usa el nombre real
                        const blob = pdfResponse.blob || pdfResponse;
                        const fileName =
                            pdfResponse.fileName ||
                            `carnet_proyecto_${id_proyecto}.pdf`;
                        const downloadURL = window.URL.createObjectURL(blob);
                        const link = document.createElement('a');
                        link.href = downloadURL;
                        link.download = fileName;
                        link.click();
                        window.URL.revokeObjectURL(downloadURL);
                        this.mensajeSuccess(
                            'Generado con exito',
                            'El carnet se ha generado y descargado correctamente.'
                        );
                        proyecto.carnetDescargado = true;
                        proyecto.carnetLoading = false;
                    },
                    error: (err) => {
                        console.error('Error al generar el PDF:', err);
                        if (err.status === 413) {
                            this.mensajeWarning(
                                'Formato demasiado grande',
                                'La imagen o datos enviados exceden el límite permitido por el servidor.'
                            );
                        } else {
                            this.mensajeWarning(
                                'Lo lamentamos',
                                'No fue posible descargar su carnet PDF'
                            );
                        }
                        proyecto.carnetDescargado = false;
                        proyecto.carnetLoading = false;
                    },
                });
        } catch (error) {
            proyecto.carnetDescargado = false;
            proyecto.carnetLoading = false;
            if (this.consoleEnabled) {
                console.error('Error al cargar datos del carnet PDF:', error);
            }
            this.mensajeWarning(
                'Lo lamentamos',
                'No fue posible descargar su carnet PDF. Intente mas tarde'
            );
        }
    }

    /*===========================================================================================*/
    /*UTILS -------------------------------------------------------------------------------------*/

    /*===========================================================================================*/
    mensajeWarning(title?: string, mensaje?: string): void {
        Swal.fire({
            title: title ? title : '...',
            text: mensaje ? mensaje : '...',
            icon: 'warning',
        });
    }

    mensajeSuccess(title?: string, mensaje?: string): void {
        Swal.fire({
            title: title ? title : '...',
            text: mensaje ? mensaje : '...',
            icon: 'success',
        });
    }

    isRegistroProfesional(proyecto?: ProyectoItem | null): boolean {
        //no hacer nada si no hay proyecto
        if (!proyecto) {
            return false;
        }
        return proyecto.nombre.startsWith('RP_') || false;
    }

    isSolicitudAprovada(): boolean {
        // console.log('issolicitu dAprobada : ', (this.registro?.['estado']=== ResolucionesComponent.aprobada) );
        console.log('this.is_solicitudAprobada : ', this.is_solicitudAprobada);
        return this.registro?.['estado'] === ResolucionesComponent.aprobada;
    }

    /* validando si posee trámites pendientes y el trámite es RP_ */
    RP(tramite: any): boolean {
        return tramite?.nombre?.startsWith('RP_') === true;
    }
}
